<script context="module">
  import { navigate as n } from 'svelte-navigator'
  import { namedRoutes } from '/routes'
  import { locale, locales, _ } from 'svelte-i18n'

  export function navigate({slug, to, section}) {
    if ( !!slug && !!section ) {
      to = namedRoutes[section].replace(":slug", slug)
    }
    if (!!to) {
      n(to)
    }
  }

</script>

<script>
  import { Link } from 'svelte-navigator'
  import { useResolve, useLocation } from 'svelte-navigator'

  export let slug="", to, section = null, link = null, hover = "underline", markdown = false, stretch = false, href = null

  const resolve = useResolve();
  const location = useLocation();

  // console.log(to, section, slug, link)
  
  if (link !== null) {
    if (typeof(link) == "string") {
      to = link
      //console.log("received link object as string", link)
    }
    else {
      section = link.section
      slug = link.slug
      to = link.to
      //console.log("received link object as slug & section: ", slug, section)
    }
  }

  //console.log(slug, section, !!slug, !!section )

  if ( !!slug && !!section ) {
    if (!namedRoutes?.[section]) console.log("route entry missing")
    //console.log("replacing", namedRoutes?.[section], slug)
    to = namedRoutes?.[section]?.replace(":slug", slug)
  }
  

  // TODO remove technical debt here...
  
  $:{

    if (typeof(to) !== "string" || !to) to = "#"
    // console.log(section, slug, to, link)

    //console.log(typeof(to), to.indexOf("http"))

    if (typeof(to) === "string" && to.indexOf("http") === 0) {
      href=to
    } else {
      let addPrefix = false
      let removePrefix = false
      if (  $locale === "de" 
            && !!to 
            && resolve(to).indexOf("/de") !== 0
      ) addPrefix = true

      if (  $locale !== "de" 
            && !!to 
            //&& resolve(to).indexOf("/de/") === 0
      ) removePrefix = true

      //if (to) console.log(to, resolve(to, $location), addPrefix, removePrefix)

      if (addPrefix) to = "/de" + to
      //if (removePrefix) to = "../" + to
    }
  }

</script>

<span 
  class="link"
  class:hover-underline={hover === "underline"}
  class:hover-outline={hover === "outline"}
  class:hover-underline-white={hover === "white-underline"}
  class:hover-none={hover === "none"}
  class:markdownStyle={markdown}
  class:stretch
>
  {#if href}
    <a {...$$restProps} href={href} >
      <slot />
    </a>
  {:else}
    <Link {...$$restProps} to={to} >
      <slot />
    </Link>
  {/if}
</span>

<style lang="scss" global>
  /* global styles! */

  .link.stretch {
    display: block;
    height: 100%;
  }

  .hover-none a:hover {
    text-decoration: none;
  }

  .hover-underline a:hover {
    text-decoration: underline;
    text-decoration-color: $color-mint;
  }

  .hover-underline-white {
    a:hover {
      text-decoration: underline;
      text-decoration-color: $color-white;
    }
  }

  .link.markdownStyle {
    text-decoration: underline;
    text-decoration-color: black;
    &:hover {
      text-decoration-color: black;
    }
  }

  .hover-outline {
    display: inline-block;
    &:hover {
      box-shadow: $link-hover-shadow;
    }
  }


</style>